// mixins
import mobileWrapperMixin from "@/mixins/mobile_wrapper/mobile-wrapper-mixin";
import { _getKey } from '@/mixins/mobile_wrapper/custom-qr-key-service';
// utils
import { dynamicParameter } from "@/mixins/service/mixin-service";

const NO_CALLBACK_ERROR = "No callback handed! Without a callback, qr-action will break after camera close. (qr-scan-mixin.js)";

/**
 * @param {Function} callback
 */
export default function (callback, singleMode = true) {
    const getCallback = dynamicParameter(callback);

    if (!callback) { window.console.error(NO_CALLBACK_ERROR); }

    return {
        mixins: [mobileWrapperMixin],
        methods: {
            /**
             * Invokes Qr-Scan with help of the MobileWrapper
             */
            async invokeQrScan() {
                if (this.$isMobileDevice()) {
                    try {
                        let taskId = await this.setTask({ callback: (data) => getCallback(this)(this._decodeData(data, singleMode)) });

                        // eslint-disable-next-line no-undef
                        return invokeCSharpQrScan(taskId); // RENAME OR REMOVING WILL BREAK MOBILEWRAPPER
                    } catch (e) {
                        window.console.error(e);
                    }
                } else {
                    return this.$pushScanQrNotification(data => getCallback(this)(this._decodeData(data, singleMode)), singleMode);
                }
            },
            /**
             * @param {array|string} data
             * @returns {{id: (number|string), key: (string)}}
             * @private
             */
            _decodeData(data, singleMode) {
                if (singleMode) return this._decodeQrData(data);
                else return data.map(item => this._decodeQrData(item))
            },
            /**
             * @param {string} qrString
             * @returns {{id: (number|string), key: (string)}}
             * @private
             */
            _decodeQrData(qrString) {
                return { key: _getKey(qrString), id: this._getId(qrString), value: qrString };
            },
            /**
             * @param {string} qrString
             * @returns {number|string}
             * @private
             */
            _getId(qrString) {
                let startOfId = this._getLastIndexOfSlash(qrString) + 1;
                return qrString.substring(startOfId);
            },
            /**
             * @param {string} string
             * @returns {number}
             * @private
             */
            _getLastIndexOfSlash(string) {
                return string.lastIndexOf('/');
            }
        },
        mounted() {
            /**
             * Callback after qr-camera of MobileWrapper closed.
             *
             * @param {string} taskId (Id of callback in store)
             * @param {string} data (content of qrCode)
             */
            window.handleCSharpQrScan = async (taskId, data) => {
                // window.console.log('handleCSharpQrScan for taskId ' + taskId);
                try {
                    let task = await this.getAndRemoveTask(taskId);
                    task.callback(data);
                } catch (e) {
                    window.console.error(e)
                }
            }
        },
        beforeDestroy() {
            delete window.handleCSharpQrScan;
        }
    }
}
